import { BlueprintInstanceType } from '../shared.enums';
import { Countertop } from './countertop.class';

import { CountertopAssetData, CountertopsDataIn, CountertopsDataOut } from './types';
import { KitchenDesignBase, KitchenDesignOptions } from '../kitchen-design-base';

import countertopAssetMap from '../data/countertop-asset.map.json';
import { deleteItemByIdCfn } from '../shared.functions';

export class Countertops extends KitchenDesignBase<CountertopsDataIn> {
	readonly children: Array<Countertop>;

	constructor (options: KitchenDesignOptions<CountertopsDataIn> = {}) {
		super(BlueprintInstanceType.Connections, options);

		this.children = [];
		if (options.dataIn?.children && options.dataIn.children.length > 0) {
			options.dataIn.children.forEach((n) => this.children.push(new Countertop({ dataIn: n, parent: this })));
		}

		this.setInitialized();
	}

	public new (islandId: string): Countertop {
		const countertop = new Countertop({
			dataIn: {
				islandIds: [islandId]
			},
			parent: this
		});
		this.children.push(countertop);
		return countertop;
	}

	/**
	 * Filters the countertops to those associated with the island id
	 * @param islandId string representing the island to match
	 * @returns Array<Countertop> or []
	 */
	public filterByIslandId (islandId: string): Array<Countertop> {
		return (this.children.filter((c) => c.islandIds.includes(islandId)) || []) as Array<Countertop>;
	}

	/**
	 * removes Countertop matching the provided id from Countertops
	 * @param id id of PanelItem to delete
	 * @returns boolean: true if remove, false if error, null when not found
	 */
	// @Publish('countertop_deleted')
	public delete (id: string): boolean {
		if (deleteItemByIdCfn(this.children, id)) {
			this.context.cache.delete(id);
			return true;
		}
		return false;
	}

	public serialize ():CountertopsDataOut {
		return {
			children: this.children.map((connection: Countertop) => connection.serialize())
		};
	}

	// ideally this would be deprecated in favor of a class for managing the asset data
	static assetData: Record<string, CountertopAssetData> = countertopAssetMap as Record<string, CountertopAssetData>
}
